export default "__VITE_ASSET__c5MfinAp__"